import React, { createContext, useContext, useState } from 'react';

const MediaUploadStatusContext = createContext<{
  isUploading: boolean;
  setIsUploading: React.Dispatch<React.SetStateAction<boolean>>;
}>({
  isUploading: false,
  setIsUploading: () => {},
});

export const useMediaUploadStatus = () => useContext(MediaUploadStatusContext);

export const MediaUploadStatusProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [isUploading, setIsUploading] = useState(false);

  return (
    <MediaUploadStatusContext.Provider value={{ isUploading, setIsUploading }}>
      {children}
    </MediaUploadStatusContext.Provider>
  );
};
